import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Slide from "@mui/material/Slide";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import { toast, ToastContainer } from "react-toastify";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import { addNewFlight } from "../Axios/Axios";
import useCustomToast from "../../hooks/useCustomToast";
import { Toaster } from "react-hot-toast";
const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  height: "900px",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "5%",
  paddingRight: "3%",
  overflow: "auto",
  zIndex: 9999,

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};
// Define the CrewPositions type to match your crew positions
type CrewPositions = {
  dualReceived: string;
  sic: string;
  pic: string;
  ip: string;
  ep: string;
  lca: string;
  solo: string;
  studentPilot: string;
};
interface UserInput {
  [key: string]: string;
}
interface CrewOption {
  label: string;
}
interface PreviewModalProps {
  open: boolean;
  onClosePr: () => void;
  onCloseFm: () => void;
  flightId: string;
  aircraftId:string,
  selectedAircraft: string;
  registrationNo: string;
  aircraftType: string;
  flightNumber: string;
  fromLoc: string;
  toLoc: string;
  date: string;
  actualOut: string;
  actualIn: string;
  totalTime: number;
  day: number;
  night: number;
  landingDay: number;
  landingNight: number;
  approachesInput: string;
  autofilledValueInstrumentTimePercent: string;
  takesOffDay: number;
  takesOffNight: number;
  crewOptionsPresent: CrewOption[][];
  userInput: UserInput;
  actualOff: string;
  actualOn: string;
  route: string;
  toCity: string;
  fromCity: string;
  crossCountry:number,
  routeDistance:number,
  arrivalDelay:number,
  departureDelay:number,
  resetAllStates: () => void;
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  resetAllStates,
  open,
  onCloseFm, // flightmodal close
  onClosePr, //preview close

  flightId,
  aircraftId,
  selectedAircraft,
  registrationNo,
  aircraftType,
  flightNumber,
  fromLoc,
  toLoc,
  date,
  actualOut,
  actualIn,
  totalTime,
  day,
  night,
  crewOptionsPresent,
  userInput,
  landingDay,
  landingNight,
  approachesInput,
  autofilledValueInstrumentTimePercent,
  actualOff,
  actualOn,
  takesOffDay,
  takesOffNight,
  route,
  toCity,
  fromCity,
  crossCountry,
  routeDistance,
  arrivalDelay,
  departureDelay
}) => {
  const navigate = useNavigate();

  const customToast = useCustomToast();

  const handleAddFlight = async () => {
    try {
      const crewPositionMapping: Record<string, keyof CrewPositions> = {
        dualReceived: "dualReceived",
        sic: "sic",
        pic: "pic",
        ip: "ip",
        ep: "ep",
        lca: "lca",
        solo: "solo",
        studentpilot: "studentPilot",
      };

      const crewPositions: CrewPositions = {
        dualReceived: "0",
        sic: "0",
        pic: "0",
        ip: "0",
        ep: "0",
        lca: "0",
        solo: "0",
        studentPilot: "0",
      };

      crewOptionsPresent.forEach((optionGroup) => {
        optionGroup.forEach((option) => {
          const label = option.label.toLowerCase();
          if (crewPositionMapping[label]) {
            crewPositions[crewPositionMapping[label]] =
              userInput[option.label] || "0";
          }
        });
      });

      console.log("crewPositions: ", crewPositions);

      const flightData = {
        flightid: flightId,
        flightNumber: flightNumber,
        flightDate: date,
        route:fromLoc+" to "+toLoc ,
        aircraft: {
          registrationNo: registrationNo,
          model: aircraftType,
          id:aircraftId,
        },
        landingsAndApproaches: {
          approaches: parseInt(approachesInput),
          hold: false,
          totalLandings: landingDay+landingNight,
          fullStopDay: landingDay,
          fullStopNight: landingNight,
          takeoffs: takesOffDay + takesOffNight,
          takeoffDay: takesOffDay,
          takeoffNight: takesOffNight,
          flightInstructor: false,
        },
        times: {
          dualReceived: userInput["Dual Received"] || crewPositions.dualReceived,
          sic: userInput["SIC"] || crewPositions.sic,
          pic: userInput["PIC"]  || crewPositions.pic,
          ip: userInput["IP"]  ||  crewPositions.ip,
          ep: userInput["EP"]  || crewPositions.ep,
          lca: userInput["LCA"] || crewPositions.lca,
          solo: userInput["SOLO"] || crewPositions.solo,
          studentPilot: userInput["Student Pilot"] || crewPositions.studentPilot,
          asInstr: 0,
          night: night,
          day: day,
          simInstrument: 0,
          imc: autofilledValueInstrumentTimePercent,
          groundSim: 0,
          totalTime: totalTime,
          totalTimeHours: totalTime,
          actual_out: new Date(actualOut),
          actual_on: new Date(actualOn),
          actual_off: new Date(actualOff),
          actual_in: new Date(actualIn),
          crossCountry:crossCountry,
          routedistance:routeDistance,
          arrival_delay:arrivalDelay,
          departure_delay:departureDelay
        },
        timesAndTelemetry: {
          flight: {
            start: fromCity,
            end: toCity,
            starticaono: fromLoc,
            endicaono: toLoc,
          },
        },
      };
      //
      // Make an HTTP POST request to the backend API endpoint
      const response = await addNewFlight(flightData);

    
        customToast("Flight added successfully","success")
        console.log("date",date)
        console.log("Flight added successfully", response);
        resetAllStates();
        onCloseFm();
        onClosePr();
        navigate("/logbook/flights");
     
    }
     catch (error) {
      customToast("Failed to add Flight","error")
      console.error("Error adding flight", error);
    }
  };

 
 

  return (
    <>
     <Toaster/>
      <Modal
        open={open}
        onClose={() => {
          onClosePr();
          onCloseFm();
        }}
      >
        <Slide direction="left" in={open} mountOnEnter unmountOnExit>
          <Box sx={style}>
            <div className="clear_icon">
              <ClearIcon style={{ marginTop: "2%" }} onClick={onClosePr} />
            </div>
            <h2 className="heading2">Add New Flight</h2>
            <p className="heading4 secondary" style={{ fontWeight: "600" }}>
              Flight Details
            </p>

            <div
              className="f-flex"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <label
                className="heading5"
                style={{ marginBottom: "5px", color: "#A5AAB0" }}
              >
                Aircraft:
              </label>
              <div
                style={{
                  width: "90%",
                  position: "relative",
                  marginBottom: "5%",
                }}
              >
                <div style={{ whiteSpace: "pre-wrap" }}>{selectedAircraft}</div>
              </div>
            </div>

            <div className="f-flex" style={{ color: "#A5AAB0" }}>
              <label
                className="heading5"
                style={{ marginBottom: "5px", display: "flex", flexGrow: "1" }}
              >
                Flight Number
              </label>
              <label
                className="heading5"
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexGrow: "1",
                }}
              >
                Date
              </label>
            </div>

            <div className="f-flex" style={{ marginBottom: "5%" }}>
              <div style={{ display: "flex", flexGrow: "1" }}>
                {flightNumber}
              </div>
              <div
                style={{ display: "flex", flexGrow: "1", marginLeft: "20%" }}
              >
                {date}
              </div>
            </div>

            <div className="f-flex" style={{ color: "#A5AAB0" }}>
              <label
                className="heading5"
                style={{ marginBottom: "5px", display: "flex", flexGrow: "1" }}
              >
                From:
              </label>
              <label
                className="heading5"
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexGrow: "1",
                  marginLeft: "8%",
                }}
              >
                To:
              </label>
            </div>

            <div className="f-flex" style={{ marginBottom: "5%" }}>
              <div style={{ display: "flex", flexGrow: "1" }}>{fromLoc}</div>
              <div style={{ display: "flex", flexGrow: "1", marginLeft: "9%" }}>
                {toLoc}
              </div>
            </div>

            <div className="f-flex" style={{ color: "#A5AAB0" }}>
              <label
                className="heading5"
                style={{ marginBottom: "5px", display: "flex", flexGrow: "1" }}
              >
                Out(UTC):
              </label>
              <label
                className="heading5"
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexGrow: "1",
                  marginLeft: "10%",
                }}
              >
                In(UTC):
              </label>
            </div>

            <div className="f-flex">
              <div style={{ display: "flex", flexGrow: "1" }}>{actualOut}</div>
              <div
                style={{ display: "flex", flexGrow: "1", marginLeft: "12%" }}
              >
                {actualIn}
              </div>
            </div>

            <p
              className="heading4 secondary"
              style={{ fontWeight: "600", marginTop: "5%" }}
            >
              TIME
            </p>

            <div style={{ display: "flex", flexGrow: "1", color: "#A5AAB0" }}>
              <label
                className="heading5"
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexGrow: "1",
                  color: "#A5AAB0",
                }}
              >
                Total Time:
              </label>
              <label
                className="heading5"
                style={{ marginBottom: "5px", display: "flex", flexGrow: "1" }}
              >
                Day:
              </label>
              <label
                className="heading5"
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexGrow: "1",
                  marginLeft: "7%",
                }}
              >
                Night:
              </label>
            </div>

            <div className="f-flex" style={{ marginBottom: "5%" }}>
              <div style={{ display: "flex", flexGrow: "1" }}>{totalTime}</div>
              <div style={{ display: "flex", flexGrow: "1" }}>{day}</div>
              <div style={{ display: "flex", flexGrow: "1" }}>{night}</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                className="heading5"
                style={{ marginBottom: "5px", color: "#A5AAB0" }}
              >
                Crew Positions:
              </label>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                {crewOptionsPresent &&
                crewOptionsPresent[0] &&
                crewOptionsPresent[0].length === 1 ? (
                  // If there is only one crew position, set totalTime to its value
                  <div
                    style={{
                      margin: "5px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {crewOptionsPresent[0].map((option, optionIndex) => {
                      if (option.label === "crewPosition") {
                        // Convert the crew position value to a number if it's numeric
                        totalTime = parseInt(userInput[option.label], 10) || 0;
                      }
                      return (
                        <div
                          key={optionIndex}
                          style={{ display: "flex", marginBottom: "5px" }}
                        >
                          <span style={{ minWidth: "100px" }}>
                            {option.label}:
                          </span>
                          <span>{totalTime}</span>
                        </div>
                      );
                    })}
                  </div>
                ) : crewOptionsPresent &&
                  crewOptionsPresent[0] &&
                  crewOptionsPresent[0].length > 1 ? (
                  // If there are multiple crew positions
                  crewOptionsPresent.map((optionGroup, groupIndex) => (
                    <div
                      key={groupIndex}
                      style={{
                        margin: "5px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {optionGroup.map((option, optionIndex) => (
                        <div
                          key={optionIndex}
                          style={{ display: "flex", marginBottom: "5px" }}
                        >
                          <span style={{ minWidth: "100px" }}>
                            {option.label}:
                          </span>
                          <span>
                            {userInput[option.label] || "-"}
                          </span>
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  // If crewOptionsPresent[0] is not defined or has length 0
                  <div
                    style={{
                      margin: "5px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", marginBottom: "5px" }}>
                      <span style={{ minWidth: "100px" }}>PIC:</span>
                      <span>{userInput["PIC"] || "-"}</span>
                    </div>
                    <div style={{ display: "flex", marginBottom: "5px" }}>
                      <span style={{ minWidth: "100px" }}>SIC:</span>
                      <span>{userInput["SIC"] || "-"}</span>
                    </div>
                    <div style={{ display: "flex", marginBottom: "5px" }}>
                      <span style={{ minWidth: "100px" }}>EP:</span>
                      <span>{userInput["EP"] || "-"}</span>
                    </div>
                    <div style={{ display: "flex", marginBottom: "5px" }}>
                      <span style={{ minWidth: "100px" }}>IP:</span>
                      <span>{userInput["IP"] || "-"}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div style={{ display: "flex", color: "#A5AAB0" }}>
              <label
                className="heading5"
                style={{ marginBottom: "5px", display: "flex", flexGrow: "1" }}
              >
                Takeoffs
              </label>
              <label
                className="heading5"
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  flexGrow: "1",
                  marginLeft: "18%",
                }}
              >
                Landings
              </label>
            </div>
            <div
              className="f-flex"
              style={{ gap: "8px", flexGrow: "1", marginBottom: "5%" }}
            >
              <div style={{ display: "flex" }}>
                Day: {takesOffDay === 1 ? 1 : ` ${takesOffDay}`}
              </div>

              <div style={{ display: "flex", marginRight: "30%" }}>
                Night: {takesOffNight}
              </div>

              <div className="f-flex" style={{ gap: "8px", flexGrow: "1" }}>
                <div style={{ display: "flex", marginLeft: "10%" }}>
                  Day: {landingDay === 1 ? 1 : `${landingDay}`}
                </div>
                <div style={{ display: "flex" }}>Night: {landingNight}</div>
              </div>
            </div>

            <div className="f-flex" style={{ color: "#A5AAB0" }}>
              {approachesInput || autofilledValueInstrumentTimePercent ? (
                <label
                  className="heading5"
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexGrow: "1",
                  }}
                >
                  Approaches:
                </label>
              ) : null}

              {autofilledValueInstrumentTimePercent ? (
                <label
                  className="heading5"
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexGrow: "1",
                    marginLeft: "20%",
                  }}
                >
                  Instrument Time %:
                </label>
              ) : null}
            </div>

            <div className="f-flex" style={{ marginBottom: "5%" }}>
              <div style={{ display: "flex", flexGrow: "1" }}>
                {approachesInput ? approachesInput : null}
              </div>
              <div
                style={{ display: "flex", flexGrow: "1", marginLeft: "15%" }}
              >
                {autofilledValueInstrumentTimePercent
                  ? autofilledValueInstrumentTimePercent
                  : null}
              </div>
            </div>

            <div className="f-flex" style={{ color: "#A5AAB0" }}>
              {actualOff || actualOn ? (
                <label
                  className="heading5"
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexGrow: "1",
                  }}
                >
                  Out(UTC)
                </label>
              ) : null}
              {actualOn ? (
                <label
                  className="heading5"
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexGrow: "1",
                    marginLeft: "10%",
                  }}
                >
                  In(UTC)
                </label>
              ) : null}
            </div>

            <div className="f-flex" style={{ marginBottom: "5%" }}>
              <div style={{ display: "flex", flexGrow: "1" }}>
                {actualOff ? actualOff : null}
              </div>
              <div
                style={{ display: "flex", flexGrow: "1", marginLeft: "10%" }}
              >
                {actualOn ? actualOn : null}
              </div>
            </div>

            <button
              className="add_btn"
              style={{ float: "right", marginBottom: "5%" }}
              onClick={handleAddFlight}
            >
              Add Flight
            </button>
            <button
              className="add_btn"
              style={{
                float: "right",
                background: "#00AF80",
                marginRight: "2%",
              }}
              onClick={onClosePr}
            >
              Back
            </button>
          </Box>
        </Slide>
      </Modal>
    </>
  );
};

export default PreviewModal;
